import React, { useState } from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import toast from 'react-hot-toast';
import SafeIcon from '../../common/SafeIcon';
import { FiSave } from 'react-icons/fi';


const EmailSettings = () => {
  const { settings, updateSettings } = useSettings();
  const [formData, setFormData] = useState({
    emailSignature: settings.emailSignature || '',
    defaultEmailTemplate: settings.defaultEmailTemplate || ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    updateSettings(formData);
    toast.success('Email settings saved successfully');
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const defaultTemplate = `Hi ${'{{firstName}}'},

I hope this email finds you well. I wanted to reach out regarding...

Best regards,
Your Name`;

  const defaultSignature = `Best regards,
Your Name
Your Title
Your Company
Phone: +1 (555) 123-4567
Email: your.email@company.com`;

  return (
    <div className="p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Email Configuration</h3>
        <p className="text-gray-600">
          Configure your default email templates and signature for automated campaigns.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Default Email Template
          </label>
          <textarea
            name="defaultEmailTemplate"
            value={formData.defaultEmailTemplate}
            onChange={handleChange}
            rows={8}
            placeholder={defaultTemplate}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <p className="mt-2 text-sm text-gray-500">
            Use variables like {'{'}{'{'} firstName {'}'}{'}'},  {'{'}{'{'} lastName {'}'}{'}'},  {'{'}{'{'} company {'}'}{'}'}  to personalize emails.
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email Signature
          </label>
          <textarea
            name="emailSignature"
            value={formData.emailSignature}
            onChange={handleChange}
            rows={6}
            placeholder={defaultSignature}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <p className="mt-2 text-sm text-gray-500">
            This signature will be automatically added to all your emails.
          </p>
        </div>

        <div className="bg-blue-50 rounded-lg p-4">
          <h4 className="font-medium text-blue-900 mb-2">Email Variables</h4>
          <p className="text-sm text-blue-700 mb-2">
            Use these variables in your templates and signatures:
          </p>
          <div className="grid grid-cols-2 gap-2">
            {[
              '{{firstName}}', '{{lastName}}', '{{email}}', '{{phone}}',
              '{{company}}', '{{title}}', '{{currentDate}}', '{{currentTime}}'
            ].map(variable => (
              <span key={variable} className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded font-mono">
                {variable}
              </span>
            ))}
          </div>
        </div>

        <div className="flex justify-end pt-6 border-t border-gray-200">
          <button
            type="submit"
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <SafeIcon icon={FiSave} className="text-sm" />
            Save Settings
          </button>
        </div>
      </form>
    </div>
  );
};

export default EmailSettings;